import { render, staticRenderFns } from "./RequestHeaders.vue?vue&type=template&id=4a71a70c"
import script from "./RequestHeaders.vue?vue&type=script&lang=js"
export * from "./RequestHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports